import tabs from '../../layouts/tabs';

tabs();
